module.exports = __webpack_public_path__ + "3a88f084ceeaf460b68161c7b96ba002.svg";